export default __webpack_public_path__ + "static/media/unauthorise-repair2.6a6b8757.png";